var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
import h from "../helper/helper";
var validator = require("validation/validator");
import Observer from "../asset/observer";
import SecuredDataApi from "../asset/securedDataWithMetaData";
import * as Bluebird from "bluebird";
var debug = require("debug");
var userService = require("users/userService").default;
import socket from "../services/socket.service";
import ObjectLoader from "../services/cachedObjectLoader";
var keyStore = require("services/keyStore.service").default;
var sessionService = require("services/session.service").default;
import ChatTitleUpdate from "./chatTitleUpdate";
var debugName = "whispeer:chunk";
var chunkDebug = debug(debugName);
var CHUNK_SECURED_DATA_OPTIONS = {
    type: "topic",
    alternativeType: "chatChunk" // Allow for chatChunk already
};
var Chunk = /** @class */ (function (_super) {
    __extends(Chunk, _super);
    function Chunk(_a, chunkData) {
        var content = _a.content, server = _a.server, meta = _a.meta, receiverObjects = _a.receiverObjects;
        var _this = _super.call(this) || this;
        _this.chunkData = chunkData;
        _this.title = "";
        _this.create = function (_a) {
            var _b = _a.server, id = _b.id, chatID = _b.chatID;
            _this.id = id;
            _this.chatID = chatID;
            ChunkLoader.addLoaded(id, _this);
            ChunkLoader.removeLoaded(-1);
        };
        _this.getChatID = function () { return _this.chatID; };
        _this.getSecuredData = function () {
            return _this.securedData;
        };
        _this.getHash = function () {
            return _this.securedData.getHash();
        };
        _this.getID = function () {
            return h.parseDecimal(_this.id);
        };
        _this.getTime = function () {
            if (_this.createTime) {
                return _this.createTime;
            }
            return _this.getSecuredData().metaAttr("createTime");
        };
        _this.getKey = function () {
            return _this.securedData.metaAttr("_key");
        };
        _this.setLatestTitleUpdate = function (titleUpdate) {
            _this.titleUpdate = titleUpdate;
        };
        _this.ensureChunkChain = function (predecessor) {
            if (_this.getID() === predecessor.getID()) {
                return;
            }
            var predecessorID = _this.getPredecessorID();
            if (!predecessorID || !ChunkLoader.isLoaded(predecessorID)) {
                throw new Error("Chunk chain broken " + predecessorID);
            }
            var predecessorChunk = ChunkLoader.getLoaded(predecessorID);
            predecessorChunk.verifyParent(_this);
            predecessorChunk.ensureChunkChain(predecessor);
        };
        _this.verifyParent = function (chunk) {
            chunk.getSecuredData().checkParent(_this.getSecuredData());
        };
        _this.getReceivers = function () {
            return _this.receiverObjects;
        };
        _this.getPartners = function () {
            return _this.receiverObjects.filter(function (receiverObject) {
                return !receiverObject.user.isOwn() || _this.receiverObjects.length === 1;
            });
        };
        _this.getPartnerDisplay = function (maxDisplay) {
            if (maxDisplay === void 0) { maxDisplay = 3; }
            var partners = _this.getPartners();
            if (partners.length <= maxDisplay) {
                return partners;
            }
            return partners.slice(0, maxDisplay - 1);
        };
        _this.getReceiver = function () {
            return _this.receiver;
        };
        _this.getAdmins = function () {
            return _this.admins;
        };
        _this.getReceiverIDs = function () {
            return _this.receiver;
        };
        _this.getTitle = function () {
            if (_this.titleUpdate) {
                return _this.titleUpdate.state.title;
            }
            return _this.title;
        };
        _this.setTitle = function (title) {
            _this.title = title;
        };
        _this.isAdmin = function (user) {
            return _this.getAdmins().indexOf(user.getID()) > -1;
        };
        _this.amIAdmin = function () {
            return _this.isAdmin(userService.getOwn());
        };
        _this.getCreator = function () {
            return h.parseDecimal(_this.securedData.metaAttr("creator"));
        };
        _this.hasPredecessor = function () {
            return !!_this.predecessorID;
        };
        _this.getPredecessorID = function () {
            if (!_this.hasPredecessor()) {
                return null;
            }
            return h.parseDecimal(_this.predecessorID);
        };
        _this.getPredecessor = function () {
            if (!_this.hasPredecessor()) {
                return Bluebird.resolve(null);
            }
            return ChunkLoader.get(_this.getPredecessorID()).catch(function (err) {
                console.log(err);
                return null;
            }, socket.errors.Server);
        };
        _this.setSuccessor = function (successorID) {
            _this.successorID = successorID;
            chunkDebug("Set successor of chunk ", _this.getID(), " succ: ", successorID);
            _this.notify({ successorID: successorID }, "successor");
        };
        _this.hasKnownSuccessor = function () {
            return !!_this.successorID;
        };
        _this.getLoadedSuccessor = function () {
            if (!_this.hasKnownSuccessor()) {
                return;
            }
            return ChunkLoader.getLoaded(_this.successorID);
        };
        _this.getSuccessor = function () {
            if (_this.successorID) {
                return ChunkLoader.get(_this.successorID);
            }
            return socket.emit("chat.chunk.successor", { id: _this.getID() }).then(function (response) {
                if (!response.chunk) {
                    return;
                }
                return ChunkLoader.load(response.chunk).then(function (successorChunk) {
                    if (successorChunk.getPredecessorID() !== _this.getID()) {
                        throw new Error("server returned invalid successor chunk");
                    }
                    return successorChunk;
                });
            });
        };
        var err = validator.validate("topic", meta);
        if (err) {
            throw err;
        }
        meta.receiver.sort();
        _this.securedData = SecuredDataApi.createRaw(content, meta, CHUNK_SECURED_DATA_OPTIONS);
        _this.id = server.id;
        _this.chatID = server.chatID;
        _this.predecessorID = server.predecessorID;
        _this.createTime = server.createTime;
        _this.receiver = _this.securedData.metaAttr("receiver").map(h.parseDecimal);
        var metaAdmins = _this.securedData.metaAttr("admins");
        var creator = _this.securedData.metaAttr("creator");
        _this.admins = (metaAdmins ? metaAdmins : [creator]).map(h.parseDecimal);
        if (_this.securedData.hasContent()) {
            _this.title = _this.securedData.contentGet().title;
        }
        else {
            _this.title = "";
        }
        _this.receiverObjects = receiverObjects;
        var predecessorID = _this.getPredecessorID();
        if (predecessorID && ChunkLoader.isLoaded(predecessorID)) {
            ChunkLoader.getLoaded(predecessorID).setSuccessor(_this.getID());
        }
        return _this;
    }
    Chunk.loadChunkChain = function (newChunk, oldChunk) {
        if (newChunk.getID() === oldChunk.getID()) {
            return Bluebird.resolve();
        }
        if (newChunk.getPredecessorID() === oldChunk.getID()) {
            return Bluebird.resolve();
        }
        return newChunk.getPredecessor().then(function (pred) {
            if (!pred) {
                return;
            }
            if (pred.getID() === oldChunk.getID()) {
                return;
            }
            return Chunk.loadChunkChain(pred, oldChunk);
        });
    };
    Chunk.createRawData = function (receiver, _a) {
        var _this = this;
        var _b = _a.content, content = _b === void 0 ? {} : _b, _c = _a.meta, meta = _c === void 0 ? {} : _c, givenKey = _a.givenKey, predecessorChunk = _a.predecessorChunk;
        return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
            var receiverIDs, receiverObjects, receiverObjectsExceptOwn, givenInfo, _a, cryptInfo, chunkKey, _b, chunkMeta, secured, cData;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        receiverIDs = receiver.map(function (val) { return h.parseDecimal(val); });
                        if (receiverIDs.indexOf(sessionService.getUserID()) === -1) {
                            receiverIDs.push(sessionService.getUserID());
                        }
                        return [4 /*yield*/, userService.getMultiple(receiverIDs)];
                    case 1:
                        receiverObjects = _c.sent();
                        receiverObjectsExceptOwn = receiverObjects.filter(function (receiver) { return !receiver.isOwn(); });
                        givenInfo = { cryptInfo: { receiverKeys: {}, keys: [] }, chunkKey: givenKey };
                        if (!givenKey) return [3 /*break*/, 2];
                        _b = givenInfo;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, Chunk.cryptInfo(receiverObjectsExceptOwn)];
                    case 3:
                        _b = _c.sent();
                        _c.label = 4;
                    case 4:
                        _a = _b, cryptInfo = _a.cryptInfo, chunkKey = _a.chunkKey;
                        receiverIDs.sort();
                        chunkMeta = __assign({}, meta, { createTime: new Date().getTime(), receiver: receiverIDs, creator: userService.getOwn().getID() });
                        secured = SecuredDataApi.createRaw(content, chunkMeta, { type: "topic" });
                        if (predecessorChunk) {
                            secured.setParent(predecessorChunk.getSecuredData());
                        }
                        return [4 /*yield*/, secured.signAndEncrypt(userService.getOwn().getSignKey(), chunkKey)];
                    case 5:
                        cData = _c.sent();
                        return [2 /*return*/, Object.assign({
                                chunk: cData,
                            }, cryptInfo)];
                }
            });
        }); });
    };
    ;
    Chunk.createChunkKey = function () {
        return keyStore.sym.generateKey(null, "chunkMain").then(function (chunkKey) {
            return keyStore.sym.symEncryptKey(chunkKey, userService.getOwn().getMainKey()).thenReturn(chunkKey);
        });
    };
    Chunk.cryptInfo = function (receiverObjectsExceptOwn) { return __awaiter(_this, void 0, void 0, function () {
        var receiverKeys, chunkKey, cryptKeys, cryptKeysData, cryptInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    receiverKeys = {};
                    return [4 /*yield*/, Chunk.createChunkKey()];
                case 1:
                    chunkKey = _a.sent();
                    return [4 /*yield*/, Bluebird.all(receiverObjectsExceptOwn.map(function (receiverObject) {
                            var crypt = receiverObject.getCryptKey();
                            return keyStore.sym.asymEncryptKey(chunkKey, crypt);
                        }))];
                case 2:
                    cryptKeys = _a.sent();
                    cryptKeysData = keyStore.upload.getKeys(cryptKeys);
                    receiverObjectsExceptOwn.forEach(function (receiver, index) {
                        receiverKeys[receiver.getID()] = cryptKeys[index];
                    });
                    cryptInfo = {
                        keys: cryptKeysData.concat([keyStore.upload.getKey(chunkKey)]),
                        receiverKeys: receiverKeys,
                    };
                    return [2 /*return*/, { cryptInfo: cryptInfo, chunkKey: chunkKey }];
            }
        });
    }); };
    return Chunk;
}(Observer));
export { Chunk };
Observer.extend(Chunk);
var decryptAndVerifyTitleUpdate = function (titleUpdate) {
    return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
        var content, meta, server, securedData, sender;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!titleUpdate) {
                        return [2 /*return*/];
                    }
                    content = titleUpdate.content, meta = titleUpdate.meta, server = titleUpdate.server;
                    securedData = SecuredDataApi.load(content, meta, { type: "topicUpdate" });
                    return [4 /*yield*/, userService.get(meta.userID)];
                case 1:
                    sender = _a.sent();
                    return [4 /*yield*/, Bluebird.all([
                            securedData.decrypt(),
                            sender.isNotExistingUser() ? false : securedData.verify(sender.getSignKey())
                        ])];
                case 2:
                    _a.sent();
                    return [2 /*return*/, {
                            content: securedData.contentGet(),
                            meta: securedData.metaGet(),
                            server: server
                        }];
            }
        });
    }); });
};
var ChunkLoader = /** @class */ (function (_super) {
    __extends(ChunkLoader, _super);
    function ChunkLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ChunkLoader;
}(ObjectLoader({
    cacheName: "chunk",
    download: function (id) { return socket.emit("chat.chunk.get", { id: id }); },
    restore: function (_a) {
        var meta = _a.meta, content = _a.content, server = _a.server, titleUpdate = _a.titleUpdate;
        return Bluebird.try(function () {
            return __awaiter(this, void 0, void 0, function () {
                var loadReceiverPromise, creator, chunk, _a, _b, chatTitleUpdate, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            loadReceiverPromise = userService.getMultipleFormatted(meta.receiver.sort().map(h.parseDecimal));
                            return [4 /*yield*/, userService.get(meta.creator)];
                        case 1:
                            creator = _e.sent();
                            if (!creator.isNotExistingUser()) {
                                keyStore.security.addEncryptionIdentifier(meta._key);
                            }
                            else {
                                // TODO data.disabled = true;
                            }
                            _a = Chunk.bind;
                            _b = {
                                meta: meta,
                                content: content,
                                server: server
                            };
                            return [4 /*yield*/, loadReceiverPromise];
                        case 2:
                            chunk = new (_a.apply(Chunk, [void 0, (_b.receiverObjects = _e.sent(),
                                    _b)]))();
                            if (!titleUpdate) return [3 /*break*/, 4];
                            _c = ChatTitleUpdate.bind;
                            _d = {
                                content: titleUpdate.content,
                                meta: titleUpdate.meta,
                                server: titleUpdate.server
                            };
                            return [4 /*yield*/, userService.get(titleUpdate.meta.userID)];
                        case 3:
                            chatTitleUpdate = new (_c.apply(ChatTitleUpdate, [void 0, (_d.sender = _e.sent(),
                                    _d)]))();
                            chunk.setLatestTitleUpdate(chatTitleUpdate);
                            _e.label = 4;
                        case 4: return [2 /*return*/, chunk];
                    }
                });
            });
        });
    },
    load: function (_a) {
        var content = _a.content, meta = _a.meta, server = _a.server, latestTitleUpdate = _a.latestTitleUpdate;
        return Bluebird.try(function () {
            return __awaiter(this, void 0, void 0, function () {
                var securedData, creator, titleUpdate;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            securedData = SecuredDataApi.load(content, meta, CHUNK_SECURED_DATA_OPTIONS);
                            return [4 /*yield*/, userService.get(securedData.metaAttr("creator"))];
                        case 1:
                            creator = _a.sent();
                            return [4 /*yield*/, decryptAndVerifyTitleUpdate(latestTitleUpdate)];
                        case 2:
                            titleUpdate = _a.sent();
                            return [4 /*yield*/, Bluebird.all([
                                    securedData.decrypt(),
                                    creator.isNotExistingUser() ? false : securedData.verify(creator.getSignKey())
                                ])];
                        case 3:
                            _a.sent();
                            return [2 /*return*/, {
                                    content: securedData.contentGet(),
                                    meta: securedData.metaGet(),
                                    server: server,
                                    titleUpdate: titleUpdate
                                }];
                    }
                });
            });
        });
    },
    getID: function (response) { return response.server.id; }
})));
export default ChunkLoader;



//////////////////
// WEBPACK FOOTER
// ./js/messages/chatChunk.ts
// module id = null
// module chunks = 